<template>
  <div class="p-box__info">
    <div class="c-info">
      <div class="c-info__content">
        <p>{{ $t('labels.referToBusinessHoursOnOwnWebsite') }}</p>
      </div>
      <div :class="`c-info__icon status status__${status}`">
        <span v-if="['prepared', 'preparing'].includes(status)">{{ $t('models.businessHoursCrawler.status.preparing') }}</span>
        <Icon v-else-if="status === 'succeeded'" name="iconOk" />
        <Icon v-else-if="status === 'failed'" name="iconNg" />
        <span v-else>{{ $t('models.businessHoursCrawler.status.notSet') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon'

export default {
  name: 'BusinessHoursCrawlerStatus',
  components: {
    Icon,
  },
  props: {
    status: {
      type: String,
      default: 'NotSet'
    },
  },
}
</script>

<style lang="scss" scoped>
.c-info__icon {
  padding: 0px 6px 0px 12px;
}

.status {
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;

  &__prepared {
    opacity: 0.5;
  }

  &__preparing {
    opacity: 0.5;
  }
}
</style>
